// extracted by mini-css-extract-plugin
export var cancelButton = "_n7-5";
export var content = "_n7-3";
export var createButton = "_n7-6";
export var drawerContainer = "_n7-0";
export var footer = "_n7-2";
export var header = "_n7-1";
export var orderFormColumn = "_n7-4";